import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

export const getAlianzasList = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/club-beneficios/alianzas",
    config
  );

  return serverResponse.data;
};

export const getAlianzas = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/alianzasintermx/list",
    config
  );

  return serverResponse.data.data;
};

export const getActiveAlianzas = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/alianzasintermx/active",
    config
  );

  return serverResponse;
};

export const getAlianzaByEmision = async (emision_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const body = { emision_id };

  const serverResponse = await mainAxios.post(
    "/v1/alianzasintermx/emision",
    body,
    config
  );

  return serverResponse.data.data;
};

export const getAlianzaById = async (id) => {
    try {
        const response = await mainAxios.get(`v1/alianzasintermx/find/${id}`, {
            headers: {
                Authorization: `Bearer ${getAgenteAccessToken()}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching Alianza by ID:", error);
        throw error;
    }
};

export const saveAlianza = async (payload) => {
    try {
        const response = await mainAxios.post(`v1/alianzasintermx/insert`, payload, {
            headers: {
                Authorization: `Bearer ${getAgenteAccessToken()}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error saving Alianza:", error);
        throw error;
    }
};

export const updateAlianza = async (id, payload) => {
    try {
        const response = await mainAxios.put(`v1/alianzasintermx/update/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${getAgenteAccessToken()}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating Alianza:", error);
        throw error;
    }
};

export const getAlianzasSinEmision = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/alianzasintermx/redencion-sin-emision",
    config
  );

  return serverResponse.data;
};
